import { render, staticRenderFns } from "./AppRoiCalculator.vue?vue&type=template&id=0a3d8c27&scoped=true"
import script from "./AppRoiCalculator.vue?vue&type=script&lang=js"
export * from "./AppRoiCalculator.vue?vue&type=script&lang=js"
import style0 from "./AppRoiCalculator.vue?vue&type=style&index=0&id=0a3d8c27&prod&scoped=true&lang=css"
import style1 from "./AppRoiCalculator.vue?vue&type=style&index=1&id=0a3d8c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d8c27",
  null
  
)

export default component.exports